// extracted by mini-css-extract-plugin
export default {"button":"button__Xjxi0h","form":"form__pAccov"};